import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { AppointmentPaymentPill, AppointmentStatusPill } from './AppointmentStatusPill';
import { getAppointmentStatusPillMeta } from './appointmentStatusPillUtils';
import './styles/UpcomingAppointmentListItem.css';

function parseAppointmentDate(date) {
  if (!date) return null;
  try {
    return date.toDate ? date.toDate() : new Date(date);
  } catch {
    return null;
  }
}

const UpcomingAppointmentListItem = ({
  appointment,
  onClick,
  getServiceName,
}) => {
  const {
    clientName,
    dateTime,
    status,
    service,
    serviceName,
    completedAt,
  } = appointment;

  const startDate = useMemo(() => parseAppointmentDate(dateTime), [dateTime]);
  const completedDate = useMemo(() => parseAppointmentDate(completedAt), [completedAt]);

  const timeLabel = startDate ? format(startDate, 'h:mm a') : '--';
  const dateLabel = startDate ? format(startDate, 'EEE, MMM d') : 'No date';

  const serviceDisplay =
    service?.name || serviceName || (getServiceName ? getServiceName(appointment) : 'No service');

  const pillMeta = useMemo(
    () => getAppointmentStatusPillMeta(appointment, appointment.rescheduleStatus),
    [appointment]
  );

  return (
    <button
      type="button"
      className={`upcoming-appt-row upcoming-appt-row--${pillMeta.className}`}
      onClick={() => onClick?.(appointment)}
    >
      <span className="upcoming-appt-row__accent" aria-hidden="true" />

      <span className="upcoming-appt-row__time">
        <span className="upcoming-appt-row__time-value">{timeLabel}</span>
        <span className="upcoming-appt-row__date-value">{dateLabel}</span>
      </span>

      <span className="upcoming-appt-row__body">
        <span className="upcoming-appt-row__top">
          <span className="upcoming-appt-row__client">{clientName || 'Client'}</span>
          <span className="upcoming-appt-row__badges">
            <AppointmentStatusPill appointment={appointment} />
            <AppointmentPaymentPill appointment={appointment} />
          </span>
        </span>

        <span className="upcoming-appt-row__service">{serviceDisplay}</span>

        {status === 'completed' && completedDate ? (
          <span className="upcoming-appt-row__footnote">
            Completed {format(completedDate, 'MMM d · h:mm a')}
          </span>
        ) : null}
      </span>

      <span className="upcoming-appt-row__chevron" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M9 6l6 6-6 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};

export default React.memo(UpcomingAppointmentListItem);
